export default __webpack_public_path__ + "static/media/image-balloon.6d0775be.png";